export const campCreateTranslations = {
    en: {
        createCamp: "Create Camp",
        editCamp: "Edit Camp",
        campDetails: "Camp Details",
        locationDetails: "Location Details",
        otherDetails: "Other Details",
        organizerDetails: "Organizer Details",
        organizerDepartment: "Organizer Department",
        selectOrganizerDepartment: "Select Organizer Department",
        expectedBeneficiaries: "Expected Beneficiaries",
        enterExpectedBeneficiaries: "Enter expected beneficiaries",
        selectAll: "Select All",
        campName: "Camp Name",
        campType: "Camp Type",
        campStart: "Camp Start",
        campEnd: "Camp End",
        description: "Description",
        pincode: "Pin Code",
        circle: "Circle",
        district: "District",
        taluka: "Taluka",
        village: "Village/Locality",
        getLocation: "Get Location",
        campAddress: "Camp Address",
        gender: "Gender",
        ageGroup: "Age Group",
        remark: "Remark",
        submit: "Submit",
        update: "Update",
        selectTypes: "Select Types",
        selectDistrict: "Select District",
        selectTaluka: "Select Taluka",
        selectGender: "Select Gender",
        selectAgeGroup: "Select Age Group",
        enterCampName: "Enter Camp Name",
        enterDescription: "Enter Description",
        enterPincode: "Enter Pincode",
        enterVillage: "Enter Village",
        enterAddress: "Enter Address",
        enterRemark: "Enter Remark",
        // Validations
        required: "is required",
        invalidPincode: "Invalid Pincode",
        fetchError: "Failed to fetch details",
        minLength: "must be at least",
        maxLength: "must be at most",
        characters: "characters",
        invalidFormat: "Invalid format",
        endDateError: "End date must be after start date",
        selectAtLeast: "Select at least one",
        campCreatedSuccess: "Camp created successfully",
        campUpdatedSuccess: "Camp updated successfully",
        campCreateFailed: "Failed to create camp",
        campUpdateFailed: "Failed to update camp",
        fetchDetailsFailed: "Failed to fetch campaign details",
    mustBe5DaysFuture: "must be at least 5 days from today"
    },
    mr: {
        createCamp: "शिबिर तयार करा",
        editCamp: "शिबिर संपादित करा",
        campDetails: "शिबिर तपशील",
        locationDetails: "ठिकाण तपशील",
        otherDetails: "इतर तपशील",
        organizerDetails: "आयोजक तपशील",
        organizerDepartment: "आयोजक विभाग",
        selectOrganizerDepartment: "आयोजक विभाग निवडा",
        expectedBeneficiaries: "अपेक्षित लाभार्थी",
        enterExpectedBeneficiaries: "अपेक्षित लाभार्थी प्रविष्ट करा",
        selectAll: "सर्व निवडा",
        campName: "शिबिराचे नाव",
        campType: "शिबिराचा प्रकार",
        campStart: "शिबिर प्रारंभ",
        campEnd: "शिबिर समाप्ती",
        description: "वर्णन",
        pincode: "पिन कोड",
        circle: "परिमंडळ (Circle)",
        district: "जिल्हा",
        taluka: "तालुका",
        village: "गाव/परिसर",
        getLocation: "स्थान मिळवा",
        campAddress: "शिबिराचा पत्ता",
        gender: "लिंग",
        ageGroup: "वयोगट",
        remark: "शेरा",
        submit: "सबमिट करा",
        update: "अद्यतनित करा",
        selectTypes: "प्रकार निवडा",
        selectDistrict: "जिल्हा निवडा",
        selectTaluka: "तालुका निवडा",
        selectGender: "लिंग निवडा",
        selectAgeGroup: "वयोगट निवडा",
        enterCampName: "शिबिराचे नाव प्रविष्ट करा",
        enterDescription: "वर्णन प्रविष्ट करा",
        enterPincode: "पिनकोड प्रविष्ट करा",
        enterVillage: "गाव प्रविष्ट करा",
        enterAddress: "पत्ता प्रविष्ट करा",
        enterRemark: "शेरा प्रविष्ट करा",
        // Validations
        required: "आवश्यक आहे",
        invalidPincode: "अवैध पिनकोड",
        fetchError: "तपशील मिळवण्यात अयशस्वी",
        minLength: "किमान असणे आवश्यक आहे",
        maxLength: "जास्तीत जास्त असणे आवश्यक आहे",
        characters: "वर्ण",
        invalidFormat: "अवैध स्वरूप",
        endDateError: "समाप्ती तारीख प्रारंभ तारखेनंतर असणे आवश्यक आहे",
        selectAtLeast: "किमान एक निवडा",
        campCreatedSuccess: "शिबिर यशस्वीरित्या तयार केले",
        campUpdatedSuccess: "शिबिर यशस्वीरित्या अद्यतनित केले",
        campCreateFailed: "शिबिर तयार करण्यात अयशस्वी",
        campUpdateFailed: "शिबिर अद्यतनित करण्यात अयशस्वी",
        fetchDetailsFailed: "मोहीम तपशील मिळवण्यात अयशस्वी",
        mustBe5DaysFuture: "आजपासून किमान ५ दिवस पुढे असावे"
    }
};
